import React from 'react';

const FilePreview = ({ fileUrl }) => {
  if (!fileUrl) return null;

  const fileExtension = fileUrl.split('.').pop().toLowerCase();

  const isImage = ['jpg', 'jpeg', 'png'].includes(fileExtension);
  const isPdf = fileExtension === 'pdf';
  const isDoc = ['doc', 'docx'].includes(fileExtension);

  return (
    <div>
      {isImage && (
        <div className='d-flex justify-content-center'>
          <img src={fileUrl} alt="Preview" style={{ maxWidth: '100%', maxHeight: '500px' }} />
          </div>
      )}

      {isPdf && (
        <iframe
          src={fileUrl}
          title="PDF Preview"
          style={{ width: '100%', height: '600px', border: 'none' }}
        ></iframe>
      )}

      {isDoc && (
        <a href={fileUrl} target="_blank" rel="noopener noreferrer" download>
          📄 Click to download/view document
        </a>
      )}
    </div>
  );
};

export default FilePreview;
